import { FC, useEffect } from "react";
import { useParams } from "react-router";
import styled from "styled-components";
import { usePMAnalytics } from "../analytics/PMAnalyticsProvider";
import { TravelSectionSettingsResource } from "../shared/types";
import { FirstStepRedirect } from "./FirstStepRedirect";
import { useIsAvailableStep } from "./provider/registrationFormProviderContext";
import { RegistrationStep } from "./RegistrationStep";

const Wrapper = styled.div`
	display: grid;
	grid-auto-rows: max-content;
	gap: ${({ theme }) => theme.spacing(5)};
`;

interface Props {
	travelSectionSettings: TravelSectionSettingsResource | null;
}

export const RegistrationStepView: FC<Props> = ({ travelSectionSettings }) => {
	const { registrationId = "", stepId = "" } = useParams<{ stepId: string; registrationId: string }>();
	const stepStatus = useIsAvailableStep(+stepId);
	const { trackRegistrationStarted } = usePMAnalytics();

	useEffect(() => {
		trackRegistrationStarted(registrationId, Number(stepId));
	}, [registrationId, stepId, trackRegistrationStarted]);

	if (!stepStatus || !stepStatus.isAvailable) {
		return <FirstStepRedirect />;
	}

	return (
		<Wrapper>
			<RegistrationStep step={stepStatus.step} travelSectionSettings={travelSectionSettings} />
		</Wrapper>
	);
};
